import { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter, Link } from "react-router-dom";

import FindMentorImg from "../../assets/images/get_mentor.jpg";
import WhoGetMentor from "./components/WhoGetMentor/WhoGetMentor";
// import './style.css'
import BenefitMentor from "./components/BenefitMentor/BenefitMentor";
import HowToPractice from "./components/HowToPractice/HowToPractice";
import FindAMentor from "./components/FindAMentor/FindAMentor";
import FindAMentorMobile from "./components/Mobile/FindAMentorMobile/FindAMentorMobile";
import ConnectExpert from "./components/ConnectExpert/ConnectExpert";
import JoinHomeMentorship from "../Home/components/JoinHomeMentorship";
import { getMentorData } from "./dependencies/action";
import { initGA, logPageView } from "../../analytics";

const FindMentor = (props) => {
  useEffect(() => {
    // const languageSelect=localStorage.getItem("SelectedLang")
    // 
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  const { getMentorData, currentInterventionList } = props;
  useEffect(() => {
    getMentorData(localStorage.getItem("SelectedLang"));
  }, [getMentorData]);

  //

  const Banner = currentInterventionList?.Banner;
  const Benefits = currentInterventionList?.Benefits;
  const FindaMentorforYourUniqueNeeds =
    currentInterventionList?.FindaMentorforYourUniqueNeeds;
  const Howtoparticipate = currentInterventionList?.Howtoparticipate;
  const Mentor = currentInterventionList?.mentor;
  const meta={
    title: 'MAARG',
    description: '',
    canonical: 'https://maarg.startupindia.gov.in/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
        }
    }
};
  return (
    <Fragment>
      <DocumentMeta {...meta}>
        {currentInterventionList ? (
          <>
            <WhoGetMentor data={Banner} />
            <BenefitMentor data={Benefits} />
            <HowToPractice data={Howtoparticipate} />
            <FindAMentor data={FindaMentorforYourUniqueNeeds} />
            <FindAMentorMobile data={FindaMentorforYourUniqueNeeds} />
            {/* <ConnectExpert data={Mentor}/> */}
          </>
        ) : null}
        {/* <JoinHomeMentorship/> */}
      </DocumentMeta>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currentInterventionList:
      state.GetMentorDataReducer.currentInerventionList.list,
  };
};
export default connect(mapStateToProps, { getMentorData })(
  withRouter(FindMentor)
);
